<template>
  <v-container class="new-campaign-terms-and-conditions">
    <p class="title-text mt-2 mb-0">{{$t('NewCampaignInitialData.termsAndConditions.title')}}</p>
    <p class="body-text text-center mt-4">{{$t('NewCampaignInitialData.termsAndConditions.introductionText')}}</p>

    <v-container class="terms-and-conditions-container my-0 px-6 py-2">
      <v-row v-if="loadingTermsAndConditions" justify="center" align="center">
        <v-progress-circular
          class="loading-icon"
          indeterminate
          size="20"
          width="3"
          color="#0098E1"
        />
      </v-row>
      <template v-else-if="termsAndConditions">
        <p class="title-text mt-2">{{ $t('NewCampaignInitialData.termsAndConditions.t&cTitle') }}</p>
        <p class="body-text mt-4" v-html="replaceWithBr(termsAndConditions.text[i18n.locale])" />
      </template>
    </v-container>

    <v-checkbox :disabled="campaign.preDataSteps[FIRESTORE_CAMPAIGN_PRE_DATA_STEPS.T_AND_C]" v-model="acceptedTermsAndConditions" :label="$t('NewCampaignInitialData.termsAndConditions.checkboxLabel')" @change="checkboxChange" hide-details />
    <v-row justify="center" align="center" class="mt-2 action-row">
      <v-btn color="#0098E1" class="submit-button" :disabled="!termsAndConditions || !acceptedTermsAndConditions" :loading="loadingButton" @click="agreeTermsAndConditions()">{{$t('NewCampaignInitialData.termsAndConditions.next')}}</v-btn>
    </v-row>
  </v-container>
</template>

<script>
import { FIRESTORE_CAMPAIGN_PRE_DATA_STEPS } from '../../constants/const'
import { completePreDataStep } from '../../lib/crudOperations/write'
import { getTermsAndConditions } from '../../lib/crudOperations/read'
import { replaceWithBr } from '../../lib/helpers'
import i18n from '../../lib/i18n'
import { trackEvent } from '../../lib/track-events'
import { EVENTS_TO_TRACK } from '../../constants/const'

export default {
  name: 'NewCampaignIntroduction',
  props: {
    nextStep: {
      type: Function,
      required: true
    },
    campaignId: {
      type: String,
      required: true
    },
    campaign: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      loadingButton: false,
      acceptedTermsAndConditions: this.campaign.preDataSteps[FIRESTORE_CAMPAIGN_PRE_DATA_STEPS.T_AND_C] || false,
      FIRESTORE_CAMPAIGN_PRE_DATA_STEPS,
      termsAndConditions: null,
      loadingTermsAndConditions: false,
      replaceWithBr,
      i18n
    }
  },
  async created () {
    this.loadingTermsAndConditions = true
    try {
      if (this.campaign.termsAndConditionsAcceptance && this.campaign.termsAndConditionsAcceptance.version) {
        this.termsAndConditions = await getTermsAndConditions(this.campaign.termsAndConditionsAcceptance.version)
      } else {
        this.termsAndConditions = await getTermsAndConditions()
      }
    } catch (error) {
      console.error('Error fetching terms and conditions:', error)
    } finally {
      this.loadingTermsAndConditions = false
    }
  },
  methods: {
    async agreeTermsAndConditions () {
      try {
        this.loadingButton = true
        trackEvent(EVENTS_TO_TRACK.CLICK_AGREE_TERMS_AND_CONDITIONS_BUTTON, {
          campaignId: this.campaignId
        })
        if (!this.campaign.preDataSteps[FIRESTORE_CAMPAIGN_PRE_DATA_STEPS.T_AND_C]) {
          await completePreDataStep(this.campaignId, FIRESTORE_CAMPAIGN_PRE_DATA_STEPS.T_AND_C, {
            't&cVersion': this.termsAndConditions.version
          })
        }
        this.nextStep()
      } catch (e) {
        console.log(e)
      } finally {
        this.loadingButton = false
      }
    },
    checkboxChange () {
      trackEvent(EVENTS_TO_TRACK.CLICK_CAMPAIGN_TERMS_AND_CONDITIONS_CHECKBOX, {
        campaignId: this.campaignId,
        acceptedTermsAndConditions: this.acceptedTermsAndConditions
      })
    }
  }
}
</script>


// WEBPACK FOOTER //
// NewCampaignTermsAndConditions.vue?5c3db9bb